import { useEffect, useState } from 'react';

import { selectCart } from '@jane/monolith/customer/redux/cart';
import { useCustomerSelector } from '@jane/monolith/customer/selectors';
import { useBrandSpecialsContext } from '@jane/shared-ecomm/providers';
import { useGetStore } from '@jane/shared/data-access';

import { CartDrawer } from './cartDrawer';
import { CartDrawerEmpty } from './cartDrawerEmpty';
import { CartDrawerError } from './cartDrawerError';
import { CartDrawerLoading } from './cartDrawerLoading';

export const CartDrawerContainer = ({
  setShowCartAlerts,
}: {
  setShowCartAlerts: (value: boolean) => void;
}) => {
  const {
    cart: cartState,
    isLoading: isLoadingCart,
    isFixingUnavailableCheckout,
  } = useCustomerSelector(selectCart);
  const status = cartState.status;

  const { showBrandSpecialAlert } = useBrandSpecialsContext();

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (isInitialLoad && !isLoadingCart) setIsInitialLoad(false);
  }, [isInitialLoad, isLoadingCart]);

  useEffect(() => {
    if (
      showBrandSpecialAlert ||
      (!isFixingUnavailableCheckout && cartState.unavailable_products.length)
    ) {
      setShowCartAlerts(true);
    }
  }, [
    isFixingUnavailableCheckout,
    cartState.unavailable_products.length,
    showBrandSpecialAlert,
  ]);

  const {
    data: store,
    isLoading: isLoadingStore,
    isError,
  } = useGetStore(cartState.store?.id);

  const isLoading = isInitialLoad || isLoadingStore;
  const emptyCart =
    !cartState?.products?.length ||
    status !== 'pending' ||
    !cartState.store?.id ||
    !store;

  if (isLoading) return <CartDrawerLoading />;
  if (isError) return <CartDrawerError />;
  if (emptyCart) return <CartDrawerEmpty />;

  return <CartDrawer />;
};
